module.exports = __webpack_public_path__ + "/assets/images/person-white-skin.jpg";